<template>
  <div id="content">
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <h1 v-translate>Přidat profil streamu</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section v-show="$_createActionAllowedAllOrOwnAndGlobal">
            <div class="left">
              <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <operator-select
                    v-model="operatorIdComputed"
                    :options="operatorOptions"
                >
                </operator-select>
              </div>
            </div>
          </section>
          <section>
            <div class="left">
              <h2 v-translate>Základní údaje</h2>
            </div>
            <stream-profile-basic-form
                :entity="entity"
                :is-editable="true"
                ref="streamprofileformref"
            ></stream-profile-basic-form>
          </section>
          <stream-profile-metadata-form
            :entity="entity"
            :is-editable="true"
            ref="streamprofilemetadataformref"
            />
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
              <input type="submit" :value="'Uložit' | translate"
                     :class="['btn']"
                     @click.prevent.stop="createEntity()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import StreamProfileBasicForm from "@/components/views/streamProfiles/forms/StreamProfileBasicForm"
import StreamProfileMetadataForm from "@/components/views/streamProfiles/forms/StreamProfileMetadataForm"
import streamProfiles from "@/components/views/streamProfiles/mixins/streamProfiles"
import detailActions from "../../../components/mixins/detail-actions"

export default {
  name: "StreamProfileNew",
  components: {StreamProfileBasicForm, StreamProfileMetadataForm},
  mixins: [detailActions, streamProfiles],
  data() {
    return {
      getSelectedOperatorAfterLoad: true,
      entity: {
        name: '',
        code: '',
        id_codec: '',
        id_operator: null,
        bitrate: '',
        shaping_bitrate: null,
        interlaced: false,
        thumbnail: false,
        resolution: {
          width: '',
          height: ''
        },
        sync_group: '',
        mux_mask: null,
      },
    }
  },
  created(StreamProfileService, OperatorService) {
    this.entityService = StreamProfileService
    this.operatorService = OperatorService

    this.getOperatorsAndSetIdOperatorToEntity(true)
  },
  methods: {
    _processDetailErrorMessage(error) {
      return this.processErrorMessage(error)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/streamProfiles/StreamProfileNew.vue